import React from 'react';

interface ProductSkeletonGridProps {
  count?: number;
  darkMode?: boolean;
}

export const ProductSkeletonCard: React.FC<{ darkMode?: boolean }> = ({ darkMode = true }) => {
  return (
    <div className={`rounded-3xl border overflow-hidden p-4 space-y-4 animate-pulse transition-all ${
      darkMode ? 'bg-slate-900/95 border-slate-800/80' : 'bg-white border-slate-200'
    }`}>
      {/* Image Skeleton */}
      <div className={`w-full h-48 rounded-2xl relative overflow-hidden ${
        darkMode ? 'bg-slate-800/80' : 'bg-slate-200'
      }`}>
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer" />
      </div>

      {/* Badges Skeleton */}
      <div className="flex items-center justify-between gap-2">
        <div className={`h-4 w-24 rounded-full ${darkMode ? 'bg-slate-800' : 'bg-slate-200'}`} />
        <div className={`h-4 w-16 rounded-full ${darkMode ? 'bg-slate-800' : 'bg-slate-200'}`} />
      </div>

      {/* Title Skeleton */}
      <div className="space-y-2">
        <div className={`h-5 w-4/5 rounded-md ${darkMode ? 'bg-slate-800' : 'bg-slate-200'}`} />
        <div className={`h-3 w-3/5 rounded-md ${darkMode ? 'bg-slate-800/60' : 'bg-slate-100'}`} />
      </div>

      {/* Price & Actions Skeleton */}
      <div className={`pt-3 border-t flex items-center justify-between ${
        darkMode ? 'border-slate-800/80' : 'border-slate-100'
      }`}>
        <div className={`h-6 w-16 rounded-md ${darkMode ? 'bg-slate-800' : 'bg-slate-200'}`} />
        <div className="flex gap-2">
          <div className={`w-9 h-9 rounded-xl ${darkMode ? 'bg-slate-800' : 'bg-slate-200'}`} />
          <div className={`w-20 h-9 rounded-xl ${darkMode ? 'bg-slate-800' : 'bg-slate-200'}`} />
        </div>
      </div>
    </div>
  );
};

export const ProductSkeletonGrid: React.FC<ProductSkeletonGridProps> = ({ count = 6, darkMode = true }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
      {Array.from({ length: count }).map((_, idx) => (
        <ProductSkeletonCard key={`p-skeleton-${idx}`} darkMode={darkMode} />
      ))}
    </div>
  );
};
